import React, { Component } from 'react'; 
import {Row , Col, Button} from 'react-bootstrap';
import ModalForm from './ModalForm';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; 

export default class ComplianceForm extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedProcess:[],
      createForm:false,
    }
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.find(inventory);
      this.setState({selectedregionName:regionNames})
      }
    
  }
  componentWillReceiveProps(nextProps){
    if(this.state.createForm === true && !_.isEmpty(nextProps.compliancetemplate) && 
      !_.isEqual(this.props.compliancetemplate, nextProps.compliancetemplate)){
      this.callingModalForm(nextProps.compliancetemplate)
    }
  
  }
  regionNames = (prop) => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }
    
  }
  
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = _.filter(selectedregionName.userCenters);
      return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    const{inventory} = this.props;
     if(!_.isEmpty(inventory)){
      let clientName = _.filter(selectedcenterName.userClients);
      return clientName;
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
      let processName = _.filter(selectedclientName.userProcesses);
      return processName;
    }
  } 
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e} );
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedclientName:[], selectedcenterName:[]})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedProcess:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});    
  }
  handleSelectProcess  = (e) => {
    this.setState({selectedProcess: e});    
   
  }
  handleSelectAuditType = (e) =>{
    this.setState({selectedAuditType: e});    
  }
  
  closeModal = () => {
    this.setState({'createForm':false, compliance:[]})
    this.props.function.ResetUserData()
  }
  validateForm = () =>{    
    const {selectedclientName,selectedcenterName, selectedProcess, selectedAuditType} = this.state;
      if(!_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) && !_.isEmpty(selectedProcess) && !_.isEmpty(selectedAuditType)){
        return true }
  }
  createFormComplaince = () => {
    this.props.function.resetTemplate()
    const {selectedclientName,selectedcenterName, selectedregionName, selectedProcess, selectedAuditType} = this.state;
    this.setState({'createForm':true})
    let obj ={
    region:{'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName},
    center:[{'centerId':selectedcenterName.inventoryCenterId, 'centerName':selectedcenterName.inventoryCenterName}], 
    client:[{'clientId':selectedclientName.inventoryClientId, 'clientName':selectedclientName.inventoryClientName}], 
    process:[{'processId':selectedProcess.inventoryProcessId, "processName":selectedProcess.inventoryProcessName }],
    auditType:selectedAuditType
    }
    this.props.function.TokenValidation()   
    this.props.function.actionSearchTemplate(obj)
    
  }
  callingModalForm = (prop) =>{
    const {selectedclientName,selectedcenterName, selectedregionName, selectedProcess, selectedAuditType} = this.state;
    if(!_.isEmpty(prop)){    
    return(
      <ModalForm closeModal={this.closeModal} callTypeSelected = {selectedAuditType} 
      region={{'inventoryRegionId':selectedregionName.inventoryRegionId, 'inventoryRegionName':selectedregionName.inventoryRegionName}}
      center={{'inventoryCenterId':selectedcenterName.inventoryCenterId, 'inventoryCenterName':selectedcenterName.inventoryCenterName}} 
      client={ {'inventoryClientId':selectedclientName.inventoryClientId, 'inventoryClientName':selectedclientName.inventoryClientName}} 
      process={{'inventoryProcessId':selectedProcess.inventoryProcessId, "inventoryProcessName":selectedProcess.inventoryProcessName }}
      function={this.props.function} loginUserName={this.props.loginUserName}
      template={prop}  complianceuserData={this.props.complianceuserData} />
    )
    }
  }
  
 
   render(){
     return(<div className=''>
     <Row>
       <Col>
         <label>Region Name</label>
       </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedregionName}
         options={this.regionNames()}
         onChange={this.handleSelect}
         open={false}
         valueKey="inventoryRegionName"
         labelKey="inventoryRegionName"
         multiple={false}
         includeSelectAll={false}
         includeFilter={true}
				 clearFilterOnClose={true}
         placeholder='Select Region'
         dropdownHeight={600}
       />
       </Col>
     </Row> 
     <Row>
       <Col>
         <label>Center Name</label>
       </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedcenterName}
         options={this.centerNames()}
         onChange={this.handleSelectCenter}
         open={false}
         valueKey="inventoryCenterName"
         labelKey="inventoryCenterName"
         multiple={false}
         includeSelectAll={false}
         includeFilter={true}
				 clearFilterOnClose={true}
         placeholder='Select Center'
         dropdownHeight={600}
       />
       </Col>             
     </Row>
     <Row>
     <Col>
     <label>Client Name</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
       value={this.state.selectedclientName}
       options={this.clientNames()}
       onChange={this.handleSelectClient}
       open={false}
       valueKey="inventoryClientName"
       labelKey="inventoryClientName"
       multiple={false}
       includeSelectAll={false}
       includeFilter={true}
       clearFilterOnClose={true}
       placeholder='Select Client'
       dropdownHeight={600}
     />
     </Col>
     </Row> 
     <Row>
     <Col>
     <label>Process Name</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
       value={this.state.selectedProcess}
       options={this.processNames()}
       onChange={this.handleSelectProcess}
       open={false}
       valueKey="inventoryProcessName"
       labelKey="inventoryProcessName"
       multiple={false}
       includeSelectAll={false}
       includeFilter={true}
       clearFilterOnClose={true}
       placeholder='Select Process Name'
       dropdownHeight={600}      
     />
      </Col>
      </Row>    
      <Row>
     <Col>
     <label>Compliance Audit Types</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
       value={this.state.selectedAuditType}
       options={this.props.auditTypes? this.props.auditTypes.complianceTypeAudit: []}
       onChange={this.handleSelectAuditType}
       open={false}
      // valueKey="label"
      // labelKey="label"
       multiple={false}
       includeSelectAll={false}
       includeFilter={false}
       placeholder='Select Audit Types'
       dropdownHeight={600}      
     />
      </Col>
      </Row>
      <br/>
       <center><Button className='buttonwidth' size='md'
       onClick={this.createFormComplaince} disabled={!this.validateForm()}>Audit</Button></center>
      {(this.state.createForm) ?
          this.callingModalForm(this.props.compliancetemplate)
        : null
      }        
    </div>)
   }
  }    
